/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { Course } from './course';

export type GenericApiResponseCourseData = Course | null;
